import html2pdf from "html2pdf.js";
import { i18n } from '@/_plugins/i18n';

export function createInvoice(
        isReading,
        fileName,
        projectName,
        presetName,
        currentUser,
        dateFrom,
        dateTo,
        table,
        total,
        localISOTime
        )
{
    return new Promise((resolve, reject) => {
        var html = htmlTemplate;
        html = resolveTotalSum(html, isReading);
        html = fillTheLocale(html, isReading);
        html = html.replaceAll("{{PROJECT_NAME}}", projectName);
        html = html.replaceAll("{{PRESET_NAME}}", presetName);
        html = html.replaceAll("{{USER_NAME}}", currentUser);
        html = html.replaceAll("{{DATE_GENERATED}}", localISOTime);
        html = html.replaceAll("{{DATE_FROM}}", dateFrom);
        html = html.replaceAll("{{DATE_TO}}", dateTo);
        html = fillInvocieContent(table, html);
        if (!isReading) {
            html = html.replaceAll("{{TOTAL}}", total);
        }

        var opt = {
          // html2pdf margin order: [top, left, bottom, right]
          margin: [20, 18, 8, 18],
          filename: fileName,
          image: { type: "jpeg", quality: 0.95 },
          html2canvas: { scale: 2, useCORS: true, logging: false },
          pagebreak: {
            mode: ["css", "legacy"],
            avoid: [".pdf-keep-together", "tr.item", "tr.heading", "tr.total", "tr.information", "tr.top"]
          },
          jsPDF: { unit: "px", format: "a4", orientation: "landscape", hotfixes: ["px_scaling"] }
        };

        html2pdf().set(opt).from(html).toPdf().get("pdf").then(function(pdf) {
            var pageCount = pdf.internal.getNumberOfPages();
            var myFooter = i18n.t("project.graphViewer.reports.footer");
            pdf.setPage(pageCount);
            pdf.setFontSize(8);
            pdf.text(10, pdf.internal.pageSize.getHeight() - 10, myFooter);
            return pdf;
        }).save().then(resolve).catch(reject);
    });
}

function resolveTotalSum(html, isReading) {
    let totalHtml =
    `
    <tr class="total pdf-keep-together">
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
	    <td>{{LOCALE_TOTAL}}: {{TOTAL}}</td>
	</tr>
    `

    return html.replaceAll("{{CONTENT_TOTAL}}", isReading ? "" : totalHtml);
}

function fillTheLocale(html, isReading) {
    html = html.replaceAll("{{LOCALE_PROJECT}}", i18n.t("project.graphViewer.reports.projectName"));
    html = html.replaceAll("{{LOCALE_PRESET}}", i18n.t("project.graphViewer.reports.presetName"));
    html = html.replaceAll("{{LOCALE_USER}}", i18n.t("project.graphViewer.reports.userName"));
    html = html.replaceAll("{{LOCALE_DATE_GEN}}", i18n.t("project.graphViewer.reports.dateGen"));
    html = html.replaceAll("{{LOCALE_ID}}", i18n.t("project.graphViewer.reports.id"));
    html = html.replaceAll("{{LOCALE_UNIT}}", i18n.t("project.graphViewer.reports.unit"));
    html = html.replaceAll("{{LOCALE_DESC}}", i18n.t("project.graphViewer.reports.description"));

    html = html.replaceAll("{{LOCALE_DATE_FROM}}",
        isReading ? i18n.t("project.graphViewer.reports.reading.date") : i18n.t("project.graphViewer.reports.consumption.dateFrom"));
    html = html.replaceAll("{{LOCALE_DATE_TO}}", isReading ? "" : `${i18n.t("project.graphViewer.reports.consumption.dateTo")}:`);
    html = html.replaceAll("{{LOCALE_START_VAL}}", isReading ? "" : i18n.t("project.graphViewer.reports.consumption.startValue"));
    html = html.replaceAll("{{LOCALE_END_VAL}}", isReading ? "" : i18n.t("project.graphViewer.reports.consumption.endValue"));
    html = html.replaceAll("{{LOCALE_SUM_VAL}}",
        isReading ? i18n.t("project.graphViewer.reports.reading.value") : i18n.t("project.graphViewer.reports.consumption.sumValue"));

    if (!isReading) {
        html = html.replaceAll("{{LOCALE_TOTAL}}", i18n.t("project.graphViewer.reports.consumption.totalSum"));
    }

    return html;
}

function fillInvocieContent(table, html) {
    let content = "";
    for (let i = 0; i < table.length; i++) {
        let className = "item";
        if (i == table.length - 1) className += " last";
        content += `
        <tr class="${className} pdf-keep-together">
        <td>${table[i][0]}</td>
        <td>${table[i][1]}</td>
        <td>${table[i][5]}</td>
        <td>${table[i][2]}</td>
        <td>${table[i][3]}</td>
        <td>${table[i][4]}</td>
        </tr>
        `
    }
    return html.replaceAll("{{CONTENT}}", content);
}

var htmlTemplate =
`
<!DOCTYPE html>
<html>
	<head>
		<meta charset="utf-8" />
		<title>Viewer Report - Tronic Control s.r.o.</title>

		<style>
			.invoice-box {
				margin: auto;
				padding: 8px 4px;
				font-size: 14px;
				line-height: 20px;
				font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
			}

			.invoice-box table {
				width: 100%;
				line-height: inherit;
				text-align: left;
				border-collapse: collapse;
				table-layout: fixed;
			}

			.invoice-box table td {
				padding: 5px;
				vertical-align: top;
				word-wrap: break-word;
				overflow-wrap: break-word;
			}

			.invoice-box table tr.pdf-keep-together,
			.invoice-box table tr.item,
			.invoice-box table tr.heading,
			.invoice-box table tr.total,
			.invoice-box table tr.information,
			.invoice-box table tr.top {
				page-break-inside: avoid !important;
				break-inside: avoid-page !important;
			}

			.invoice-box table tr.pdf-keep-together td {
				page-break-inside: avoid !important;
				break-inside: avoid-page !important;
			}

			.invoice-box table tr td:nth-child(6) {
				text-align: right;
			}

			.invoice-box table tr.top table td {
				padding-bottom: 20px;
                font-size: 11px;
			}

			.invoice-box table tr.top table td.title {
				font-size: 45px;
				line-height: 45px;
			}

			.invoice-box table tr.information table td {
				padding-bottom: 40px;
			}

			.invoice-box table tr.heading td {
				border-bottom: 1px solid;
				font-weight: bold;
			}

            .invoice-box table tr.heading td.id {
				width: 5%
			}

			      .invoice-box table tr.heading td.unit {
				width: 10%
			}

            .invoice-box table tr.heading td.desc {
				width: 35%
			}

            .invoice-box table tr.heading td.start td.end {
				width: 15%
			}

            .invoice-box table tr.heading td.diff {
				width: 20%
			}

			.invoice-box table tr.details td {
				padding-bottom: 20px;
			}

			.invoice-box table tr.item td {
				border-bottom: 1px solid;
			}

			.invoice-box table tr.item.last td {
				border-bottom: none;
			}

			.invoice-box table tr.total td:nth-child(6) {
				border-top: 2px solid;
				font-weight: bold;
			}

			@media only screen and (max-width: 600px) {
				.invoice-box table tr.top table td {
					width: 100%;
					display: block;
					text-align: center;
				}

				.invoice-box table tr.information table td {
					width: 100%;
					display: block;
					text-align: center;
				}
			}

			/** RTL **/
			.invoice-box.rtl {
				direction: rtl;
				font-family: Tahoma, 'Helvetica Neue', 'Helvetica', Helvetica, Arial, sans-serif;
			}

			.invoice-box.rtl table {
				text-align: right;
			}

			.invoice-box.rtl table tr td:nth-child(6) {
				text-align: left;
			}
		</style>
	</head>

	<body>
		<div class="invoice-box">
			<table cellpadding="0" cellspacing="0">
				<tr class="top pdf-keep-together">
					<td colspan="6">
						<table>
							<tr>
								<td class="title">
									<img src="img/brand/TCLogo.png" style="width: 100%; max-width: 100px" />
								</td>

                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>

								<td>
									Tronic Control s.r.o.<br />
									info@tronic.cz<br />
									www.tronic.cz
								</td>
							</tr>
						</table>
					</td>
				</tr>

				<tr class="information pdf-keep-together">
					<td colspan="6">
						<table>
							<tr>
								<td>
									{{LOCALE_PROJECT}}: {{PROJECT_NAME}}<br />
									{{LOCALE_PRESET}}: {{PRESET_NAME}}<br />
									{{LOCALE_USER}}: {{USER_NAME}}<br />
                                    {{LOCALE_DATE_GEN}}: {{DATE_GENERATED}}
								</td>

                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>

								<td>
                                    {{LOCALE_DATE_FROM}}: {{DATE_FROM}}<br />
									{{LOCALE_DATE_TO}} {{DATE_TO}}<br />
								</td>
							</tr>
						</table>
					</td>
				</tr>

				<tr class="heading pdf-keep-together">
					<td class="id">{{LOCALE_ID}}</td>
					<td class="desc">{{LOCALE_DESC}}</td>
					<td class="unit">{{LOCALE_UNIT}}</td>
                    <td class="start">{{LOCALE_START_VAL}}</td>
                    <td class="end">{{LOCALE_END_VAL}}</td>
                    <td class="diff">{{LOCALE_SUM_VAL}}</td>
				</tr>

                {{CONTENT}}

				{{CONTENT_TOTAL}}
			</table>
		</div>
	</body>
</html>
`
